import React from 'react';
import glamorous from 'glamorous';
import {BASE_TEXT} from '../../../../shared/style/typography';
import {ASH, TARMAC} from '../../../../shared/style/colors';

const SeparatorContainer = glamorous.div({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0px 12px'
});

const VersusTextContainer = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${ASH}`,
  borderRadius: '50%',
  width: 24,
  height: 24
});

const VersusText = glamorous.div({
  ...BASE_TEXT,
  fontSize: 12,
  color: TARMAC
});

export default function ComparisonSeparator() {
  return (
    <SeparatorContainer>
      <VersusTextContainer>
        <VersusText>vs</VersusText>
      </VersusTextContainer>
    </SeparatorContainer>
  );
}
